import { SIZES } from '../../../types/sizes';
import { DescriptionTitleProps } from './VyDescriptionTitle';

type FontProps = {
  titleSize: string;
  subtitleSize: string;
};

export const SIZE_MAP: Record<Required<DescriptionTitleProps>['size'], FontProps> = {
  [SIZES.SMALL]: {
    titleSize: '14px',
    subtitleSize: '12px',
  },
  [SIZES.MEDIUM]: {
    titleSize: '16px',
    subtitleSize: '12px',
  },
  [SIZES.LARGE]: {
    titleSize: '16px',
    subtitleSize: '14px',
  },
};

